import React from 'react';
import { MailIcon, SunIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full border-t border-ink-800 bg-ink-950 py-14" data-id="element-80" data-mp="3gezdb400vr15">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-6" data-id="element-81" data-mp="3ghc0pwojutll">
        <div className="grid gap-8 sm:grid-cols-[1.4fr_1fr]" data-id="element-82" data-mp="32p5mwh8vcypb">
          <div data-id="element-83" data-mp="36p6b2tlrso9k">
            <p className="flex items-center gap-2 font-display text-lg font-900 uppercase tracking-wide text-white" data-id="element-84" data-mp="36oo9rik93jus">
              <SunIcon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-85" data-mp="3ugbsveb9tqmi" />
              El Código Solar 360°
            </p>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-slate-400" style={{
            fontSize: "28px"
          }} data-id="element-86" data-mp="37xuse6oxwgy">
              -Cero técnica requerida
-Garantía 7 días
-$17 USD.
            </p>
          </div>
          <div className="sm:text-right" data-id="element-87" data-mp="29z6uqczdolgf">
            <a href="mailto:soporte@codigosolar360.com" className="inline-flex items-center gap-2 text-sm text-slate-300 transition-colors duration-150 ease-smooth hover:text-gold" data-id="element-88" data-mp="29yduzvyu6w7s">
              <MailIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-89" data-mp="3l8qwo57filrz" />
              soporte@kodadigital.shop
            </a>
          </div>
        </div>

        <p className="mt-10 border-t border-ink-800 pt-6 text-xs leading-relaxed text-slate-500" data-id="element-90" data-mp="3gcts0w5j33v1">
          © El Código Solar 360° 2026 — Todos los derechos reservados. Prohibida la reproducción y
          redistribución sin autorización expresa.
        </p>
        <p className="mt-4 font-display text-sm font-600 italic text-gold" data-id="element-91" data-mp="81pfbipu2x9d">
          “El sol ya está produciendo. La pregunta es si estás aprovechándolo.”
        </p>
      </div>
    </footer>;
}